import { useState } from "react";
import { Frame, Node, Flow, Detail } from "@/components/diagrams/kit";

const STEPS = [
  { name: "Question", tone: "neutral", ex: "Shift C lead: “Why did Line 3 lose output overnight?”", blind: "Without a routine, the question is asked in a chat and forgotten." },
  { name: "Evidence", tone: "data", ex: "Capper micro-stops 12 → 31 → 48 min/shift (historian, Good). Torque tag stale since 09 Oct 21:14. WO-8812 deferred.", blind: "Without evidence, the answer is fluent but untrustworthy." },
  { name: "Owner", tone: "accent", ex: "Maintenance leader owns the capper check; shift supervisor owns the handover.", blind: "Without an owner, the pilot stalls: nobody acts on the insight." },
  { name: "Action", tone: "action", ex: "Approve WO-8812 chuck inspection before Shift A; verify torque with calibrated tester per SOP-C302-04 rev 3.", blind: "Without a human-approved action, nothing changes on the line." },
];

export default function HandoverFlow() {
  const [sel, setSel] = useState(0);
  const [routine, setRoutine] = useState(true);
  return (
    <Frame title="Workflow embedding: shift handover" hint="Walk the handover" testId="diagram-handover">
      <label className="mb-4 flex items-center gap-2 text-xs">
        <input type="checkbox" data-testid="handover-routine-toggle" checked={routine} onChange={(e) => setRoutine(e.target.checked)} className="accent-[hsl(var(--brand-primary))]" />
        Embedded in the existing shift-handover routine
      </label>
      <div className="flex flex-col sm:flex-row">
        {STEPS.map((s, i) => (
          <div key={s.name} className="flex flex-col sm:flex-1 sm:flex-row">
            <Node testId={`handover-step-${i}`} tone={routine ? s.tone : "danger"} active={sel === i} dim={!routine && i > 0} onClick={() => setSel(i)}>
              <div className="font-mono text-[10px] text-muted-foreground">0{i + 1}</div><div className="font-heading font-bold">{s.name}</div>
            </Node>
            {i < STEPS.length - 1 && <Flow on={routine} />}
          </div>
        ))}
      </div>
      <Detail testId="handover-detail"><span key={sel + String(routine)}>{routine ? STEPS[sel].ex : STEPS[sel].blind}</span></Detail>
    </Frame>
  );
}
